var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserSquareLogged(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_8611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 19.6664C17.9965 19.9629 16.8108 20.0997 15.42 20.0997H8.57972C7.18888 20.0997 6.00324 19.9629 5 19.6664C5.25081 16.7023 8.29471 14.3652 11.9998 14.3652C15.705 14.3652 18.7489 16.7023 18.9997 19.6664Z",
    stroke: "#333333",
    strokeWidth: 1.71006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1627 7.08136C16.1627 9.33864 14.3386 11.1741 12.0813 11.1741C9.82407 11.1741 8 9.33864 8 7.08136C8 4.82408 9.82407 3 12.0813 3C14.3386 3 16.1627 4.82408 16.1627 7.08136Z",
    stroke: "#333333",
    strokeWidth: 1.71006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 5,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.0055L17.9972 21.0111L22 17",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.0055L17.9972 21.0111L22 17",
    stroke: "white",
    strokeWidth: 1.24309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_8611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquareLogged);
export default __webpack_public_path__ + "static/media/user-square-logged.c767e829ae2509dfe8b5d1baefbe273d.svg";
export { ForwardRef as ReactComponent };